import React from "react";
import Hero from "./components/Hero";
import About from "./components/About";
import Banner from "./components/Banner";
import Banner2 from "./components/Banner2";
import Solution from "./components/Solution";
import Team from "./components/Team";
import Footer from "../Base/Footer";
import Treat from "./components/Treat";
import Treat2 from "./components/Treat2";
import Treat3 from "./components/Treat3";
import { Products } from "./components/Products";
export default function Home() {
  return (
    <>
      <div className="anchor" id="top"></div>
      <Hero />
      <About />
      <Banner />
      <Treat />
      <Treat2 />
      {/* <Treat3 /> */}
      <Banner2 />
      <Solution />
      <Products />
      <Team />
      <Footer />
      <a href="#top" className="topBtn">
        <img src="/images/icons/chevron-top.svg" alt="" />
      </a>
    </>
  );
}
